import { gql } from '@apollo/client';
import toast from 'react-hot-toast';
import { constructMutation, constructMutationVariables, client } from '@/services/apollo';

export const DELETE_MAIL_RULE = gql`
    mutation DeleteMailRule($deleteMailRuleInput: DeleteMailRuleInput!) {
        deleteMailRule(input: $deleteMailRuleInput) {
            mailRule {
                id
            }
        }
    }
`;

export const UPDATE_MAIL_RULE = gql`
    mutation UpdateMailRule($updateMailRuleInput: UpdateMailRuleInput!) {
        updateMailRule(input: $updateMailRuleInput) {
            mailRule {
                targetName
                account {
                    id
                    active
                    enabled
                    remoteId
                    email
                }
                id
                enabled
                senderEmail
                createdAt
                updatedAt
            }
            errors {
                path
                message
            }
        }
    }
`;

export const FETCH_MAIL_RULES = gql`
    query MailRules($id: ID, $sortColumn: MailRuleColumnsEnum, $sortDirection: SortDirectionEnum) {
        user {
            mailRules(id: $id, sortColumn: $sortColumn, sortDirection: $sortDirection) {
                targetName
                account {
                    id
                    active
                    enabled
                    remoteId
                    email
                    name
                }
                id
                enabled
                senderEmail
                createdAt
                updatedAt
            }
        }
    }
`;

const mailRuleMutationBody = `
mailRule {
    targetName
    account {
        id
        active
        enabled
        remoteId
        email
    }
    id
    enabled
    senderEmail
    createdAt
    updatedAt
}
`;

export const deleteSelected = async (
    items: Array<string>,
    refetch: () => void,
    closeModal: (value: boolean) => void,
    setFormError: (message: string) => void,
) => {
    const mutationString = constructMutation('DeleteMailRule', 'DeleteMailRuleInput!', 'deleteMailRule', mailRuleMutationBody, items);
    const mutationVariables = constructMutationVariables(items, false, null);

    try {
        const wrappedString = gql`${mutationString}`;

        const response = await client.mutate({
            mutation: wrappedString,
            variables: mutationVariables,
        });
        if (response) {
            setFormError('');
            toast.success('Mail Rule deleted successfully');
            closeModal(false);
        }
        refetch();
    } catch (error) {
        closeModal(false);
        setFormError('Mail Rule deletion failed, please try again');
        return error;
    }

    return null;
};

export const updateSelected = async (
    items: Array<string>,
    enabled: boolean,
    refetch: () => void,
    closeModal: (value: boolean) => void,
    setFormError: (message: string) => void,
) => {
    const mutationString = constructMutation('UpdateMailRule', 'UpdateMailRuleInput!', 'updateMailRule', mailRuleMutationBody, items);
    const mutationVariables = constructMutationVariables(items, true, { enabled });

    try {
        const wrappedString = gql`${mutationString}`;

        const response = await client.mutate({
            mutation: wrappedString,
            variables: mutationVariables,
        });
        if (response) {
            setFormError('');
            toast.success('Mail Rule updated successfully');
            closeModal(false);
            refetch();
        }
    } catch (error) {
        setFormError('Mail Rule update failed, please try again');
        closeModal(false);
        return error;
    }

    return null;
};
